<template>
  <v-content>
    <v-container fluid>
      <Header :title="'Course Vouchers'" />
      <v-row v-for="(data,index) in courses" :key="data.course_id">
      <v-col cols="12" v-if="data.plan.voucher_product_id">
        <v-card elevation="2" shaped>
            <v-container>
                <v-card-title class="headline">               
                        {{ data.course_name }}
                        <v-spacer></v-spacer>
                        <v-row>
                             <v-col cols="12" sm="2" md="2">
                                <v-label>
                                        {{ (Object.keys(currentUser).length !=0 && currentUser.company.account_type == "on-demand" ?
                                        data.plan.voucher_amount : 'Included' ) }} 
                                        <v-icon small> {{getCurrency(currentUser,data)}}</v-icon>
                                </v-label>
                            </v-col>
                           <v-col cols="12" sm="3" md="3">
                                <v-text-field 
                                    v-model = "courseData[index]['voucher_quantity']"
                                    name="voucher_quantity"
                                    type="number"
                                    label="Number of Vouchers"
                                    :rules="quantityRules"
                                    class="included-text-field"
                                    v-on:change="addVoucherQuantity(index,courseData[index]['voucher_quantity'])"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-label>
                                    Total:{{(courseData[index]['voucher_quantity']*(Object.keys(currentUser).length !=0 && currentUser.company.account_type == "on-demand" ?
                                         data.plan.voucher_amount : 0 )).toFixed(2)}} <v-icon small> {{getCurrency(currentUser,data)}}</v-icon>

                                </v-label>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-btn :color="primary_color" style='color:white;' @click='checkCard(data)' 
                                    :disabled="canOrder(index,data)"
                                >{{ 'Order'| translate }}</v-btn>
                            </v-col>
                        </v-row>
                </v-card-title>  
                <v-card-subtitle class="pt-5" v-html='data.description'></v-card-subtitle>
                <v-card-text>
                  <h5>{{ 'Modules' | translate }}</h5>
                  <v-chip-group mandatory column>
                  <v-chip v-for='(moduledata,index) in data.company_modules' :key='index' :to="'/modules/'+moduledata.module_id" >
                      {{ moduledata.title }}
                  </v-chip>             
                  </v-chip-group> 
                </v-card-text>
            </v-container>
          </v-card>
      </v-col>
      </v-row>

    </v-container>

    <v-dialog v-if="!loadingdata" v-model="dialog" persistent max-width="1000">
      <v-card >
        <v-card-title class="headline">{{ 'Order Purchase Confirmation' | translate }}</v-card-title>
            <v-card-text>
                <div class="my-4 text-subtitle-1">
                    {{this.course_name}} 
                </div>
                <div>{{this.course_description}}</div>
            </v-card-text>
            <v-card elevation="0">
              <v-row align="center" justify="space-around">
                <v-col cols="12" sm="7" lg="5">
                    <v-card-title> {{'Pay securely using' | translate}} </v-card-title>
                      <v-row>
                        <v-col v-for="(v, k) in stripeallcards" :key="k" cols="12" sm="6">
                          <v-card v-if="v.is_default" class="mx-auto" max-width="344">
                            <v-card-text>
                              <div>xxxxxxxxxxxx{{v.card_last_four}}</div>

                              <p class="display-1 text--primary">{{v.card_brand}}</p>
                              <div class="text--primary">{{ (Object.keys(currentUser).length !=0 ?  currentUser.name : '') }}</div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12">
                          <div > {{ 'Need to change payment method?' | translate }} <v-btn color="primary darken-1" text to="/profile">{{ 'Go to profile' | translate }}</v-btn></div>
                        </v-col>
                      </v-row>
                  
                </v-col>
                <v-col cols="12" sm="5">
                  <v-card max-width="800">
                    <v-card-title class="pb-0">{{'Order Summary' | translate}}</v-card-title>
                    <v-container>
                      <v-row justify="space-between">
                        <v-card-subtitle class="title py-1 pl-3">{{'Vouchers' | translate}}</v-card-subtitle>
                        <v-card-subtitle class="title py-1 pr-3">{{'Subtotal' | translate}}</v-card-subtitle>
                      </v-row>
                      <v-row justify="space-between">
                        <v-card-subtitle> {{this.course_name}} x {{ this.voucher_quantity }} </v-card-subtitle>
                        <v-card-subtitle>{{ this.voucher_price }}{{this.currency}}</v-card-subtitle>
                      </v-row>
                      
                      <v-divider></v-divider>

                      <v-row justify="space-between">
                        <v-card-subtitle class="title py-1 pl-3">{{'Total'| translate}}</v-card-subtitle>
                        <v-card-subtitle class="title py-1 pl-3">{{this.voucher_total}}{{this.currency}}</v-card-subtitle>
                      </v-row>

                      <v-row justify="center">
                         <v-checkbox v-model="agree_terms" light>
                          <template slot="label">
                            {{'I agree'| translate }} <a @click.stop href="/pages/privacy-policy" target="_blank">{{'terms'| translate}}</a>
                          </template>
                        </v-checkbox>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary darken-1" text @click="dialog = false">{{ 'Cancel' | translate }}</v-btn>
                          <v-btn color="primary darken-1" text @click="buyVouchers(course_id)" v-if="agree_terms">{{ 'Order' | translate }}</v-btn>
                        </v-card-actions>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
      </v-card>
    </v-dialog>

    <v-dialog v-model="profileLink" persistent max-width="600">
      <v-card>
        <v-card-title
          class="headline"
        >{{ 'You dont seem to have a card added to your profile' | translate }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text to="/profile">{{ 'Go to profile' | translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="vouchersuccess" persistent max-width="560">
      <v-card>
        <v-card-title class="headline">{{ "Voucher Purchased Successfully"| translate }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="vouchersuccess = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

   <v-overlay :value="isLoading">
      <v-layout row justify-center v-if="isLoading">
        <v-dialog v-model="loadingdata" persistent fullscreen content-class="loading-dialog">
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </v-overlay>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
  FETCH_COURSES,
  BUY_VOUCHERS,
  RESET_STATE,
} from "@/store/actions.type";
import { SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";
export default {
  name: "Vouchers",
   async beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_COURSES, '?type=voucher').then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false);
        store.commit(SET_ROUTER_ENTER, false)

      }
    });

    store.commit(SET_ROUTER_ENTER, false)
    return next();
  },
  computed: {
    ...mapGetters([
      "courses",
      "stripesecretkey",
      "currentUser",
      "loadingdata",
      'routerenter',
      "languages",
      "stripeallcards"
    ]),
  },
  data: function() {
    return {
      courseData:[],
      course_id: null,
      course_name: null,
      course_description: null,
      voucher_quantity: null,
      voucher_total: null,
      voucher_price: null,
      currency:null,
      agree_terms: false,
      dialog: false,
      vouchersuccess: false,
      storage_url: '',
      primary_color:'',
      profileLink: false,
      isLoading: false,
      quantityRules: [v => (!isNaN(parseInt(v)) && v > 0 )  || "Quantity Required"],
    }
      
  },
  components: {
    Header: () => import("@/components/header/Header"),
  },  
  created() {
    this.storage_url  = process.env.VUE_APP_STORAGE_URL
    let companymeta = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color = companymeta.primary_color;
    
    this.courses.forEach((item)=> {
        let voucher_amount = ((item.plan.voucher_amount)?(item.plan.voucher_amount):'0')
        this.courseData.push({'course_id':item.course_id,'voucher_price':voucher_amount,'voucher_quantity':'1','voucher_total':voucher_amount})
    })
  },
  methods: {
    canOrder(index,data){
       return (((this.courseData[index]['voucher_quantity']*(Object.keys(this.currentUser).length !==0 && this.currentUser.company.account_type == "on-demand" ? data.plan.voucher_amount : 0))>0) ? false: true) 
    },
    getCurrency(currentUser,data){
      if(Object.keys(currentUser).length !=0 && currentUser.company.account_type == 'on-demand' && data.plan.voucher_amount !== null && data.plan.currency == 'eur'){
        this.currency = "€"
        return 'mdi-currency-eur'
      }
      else if(Object.keys(currentUser).length !=0 && currentUser.company.account_type == 'on-demand' && data.plan.voucher_amount !== null){
        this.currency = "$"
        return '$'
      }
    },
    addVoucherQuantity(index,newvoucherQuantity){
      this.courseData[index]['voucher_quantity'] = newvoucherQuantity;
      this.courseData[index]['voucher_total'] = (newvoucherQuantity* this.courseData[index]['voucher_price']).toFixed(2);
    },
    checkCard(data) {
      if (this.currentUser.company.account_type == "on-demand") {
        if (this.stripeallcards.length !== 0) {
          this.dialog = true;
          this.course_id = data.course_id
          this.course_name = data.course_name
          this.course_description= data.description
          let index = this.courseData.map(function(x) {return x.course_id; }).indexOf(data.course_id)
          this.voucher_quantity= this.courseData[index]['voucher_quantity']
          this.voucher_total= this.courseData[index]['voucher_total']
          this.voucher_price= this.courseData[index]['voucher_price']
        } else {
          this.profileLink = true;
        }
      } 
    },
    buyVouchers(id) {
        let data = {
            item_id:id,
            qty: this.voucher_quantity,
          }
          if (this.currentUser.company.account_type == "on-demand") {
            this.isLoading = true
            this.$store.dispatch(BUY_VOUCHERS, data).then(resp => {
              if (resp.success) {
                  let index = this.courseData.map(function(x) {return x.course_id; }).indexOf(id)
                  this.courseData[index]['voucher_quantity'] = 1;
                  this.dialog = false;
                  this.isLoading = false;
                  store.commit(SET_LOADING, false);
                  this.vouchersuccess = true;
              }
              else if (resp.error){
                  store.commit(SET_LOADING, false);
                  this.isLoading = false;
              }
            });
          } else {
            this.isLoading = true
            this.$store.dispatch(BUY_VOUCHERS, data).then(resp => {
              if (resp != undefined && resp.success) {
                  let index = this.courseData.map(function(x) {return x.course_id; }).indexOf(id)
                  this.courseData[index]['voucher_quantity'] = 1;
                  store.commit(SET_SNACKBAR, {status: true, message:resp.message})
                  this.isLoading = false
                  store.commit(SET_LOADING, false);
              }
            });
          }
    }
  }
};
</script>
<style scoped>
.included-button{
  cursor: default !important;
}
.included-text-field {
    padding-top: 0px;
}
.included-button::before {
  background-color: transparent !important;
}
</style>